module.exports = __webpack_public_path__ + "img/bicyclette.1be4ed19.png";